import { PythonTopic } from '../../../../types/python-topic';
import { fechasCarpetasExercises } from './exercises';

export const fechasCarpetasTopic: PythonTopic = {
  id: 8,
  title: 'Fechas y Carpetas',
  description: 'Aprende a trabajar con fechas, archivos y directorios en Python.',
  theory: `# Fechas y Carpetas en Python

## ¿Qué aprenderás en esta sección?

Esta sección te introduce a:
1. **Trabajo con fechas**: Manejar fechas y tiempos
2. **Archivos y directorios**: Leer, escribir y organizar archivos
3. **Ordenamiento de archivos**: Organizar y procesar archivos

## Trabajo con Fechas

Aprenderás a:
- Trabajar con fechas y tiempos
- Formatear fechas
- Calcular diferencias de tiempo
- Manejar zonas horarias

## Archivos y Directorios

Entenderás cómo:
- Leer y escribir archivos
- Navegar directorios
- Organizar archivos programáticamente
- Procesar múltiples archivos

## Estructura de esta sección

Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo.`,
  difficulty: 'intermediate',
  exercises: fechasCarpetasExercises
};

